angular.module('components.createResellerReturnOrderArticlesQuantity', [])
    .component('createResellerReturnOrderArticlesQuantity', {
        templateUrl: 'main/resellerorder/resellerreturnordermodify/components/articlelist_quantity.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            resellerOrder: '=',
            disabled: '<',
            onArticleSelected: '&',
            onLineItemChanged: '&',
            onVariantChanged: '&'
        },
        controller: controller
    });

// @ngInject
function controller($rootScope, $scope, $state, $window, $translate, ResellerOrdersApiService, confirmationDialogService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    //Properties
    vm.lineItemsGroupedByArticle = [];

    //Methods
    vm.viewOrderArticle = viewOrderArticle;
    vm.absolute = absolute;
    vm.groupBy = groupBy;
    vm.saveLineItem = saveLineItem;
    vm.saveVariant = saveVariant;
    vm.canModifyLineItem = canModifyLineItem;
    vm.getVariant1s = getVariant1s;
    vm.getVariant2s = getVariant2s;
    vm.toggleExpandAll = toggleExpandAll;
    vm.canClearRow = canClearRow;
    vm.confirmClearRow = confirmClearRow;
    vm.removeArticleFromOrder = removeArticleFromOrder;
    vm.canDeleteArticleFromOrder = canDeleteArticleFromOrder;
    vm.canUpdateWholeRow = canUpdateWholeRow;
    vm.updateWholeRow = updateWholeRow;
    vm.getProductQuantitySum = getProductQuantitySum;
    vm.getTotalQuantitySum = getTotalQuantitySum;
    vm.getVariantQuantitySum = getVariantQuantitySum;
    vm.getProductGrossPrice = getProductGrossPrice;
    vm.canModifyLineItemDeliveryDate = canModifyLineItemDeliveryDate;
    vm.deliveryDateChanged = deliveryDateChanged;
    vm.setWholeRowPrice = setWholeRowPrice;
    vm.setWholeRowDiscountPercent = setWholeRowDiscountPercent;
    vm.getFinalAmount = getFinalAmount;
    vm.goToProduct = goToProduct;

    function onInit() {
        if (vm.resellerOrder.lineItems === undefined) {
            vm.resellerOrder.lineItems = [];
        } else {
            regroupLineItemsOnArticle();
        }

        $scope.$watch(function () { return vm.resellerOrder.lineItems.length; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                regroupLineItemsOnArticle();
            }
        });
        $rootScope.$on('ResellerOrder.hideLineSpinner', function() {
            vm.showSpinner = false;
        });
    }
    function onChanges() {
    }
    function onDestroy() {
    }

    function goToProduct(articleId) {
        var url = $state.href('product.articles.article', {articleId: articleId});
        $window.open(url,'_blank');
    }

    function getFinalAmount(lineItemArticle, variant) {
        var avgPrice = parseFloat(vm.getProductGrossPrice(lineItemArticle).toFixed(2));
        if (!variant.wholeRowPrice) { variant.wholeRowPrice = avgPrice; }
        if (!variant.wholeRowDiscountPercent) { variant.wholeRowDiscountPercent = 0; }

        var temp = parseFloat((variant.wholeRowPrice * (1 - variant.wholeRowDiscountPercent)).toFixed(2));
        return temp;
    }

    function setWholeRowPrice(lineItemArticle, variant) {
        var avgPrice = parseFloat(vm.getProductGrossPrice(lineItemArticle).toFixed(2));
        if (!variant.wholeRowPrice) { variant.wholeRowPrice = avgPrice; }
        variant.wholeRowFinalPrice = parseFloat((variant.wholeRowPrice * (1 - variant.wholeRowDiscount / 100)).toFixed(2));

        _.forEach(variant.lineItems, function(li) {
            if (!li.amount || li.amount === 0) {
                li.amount = variant.wholeRowPrice;
                li.finalAmount = parseFloat((parseFloat(variant.wholeRowPrice) * (1 - parseFloat(variant.wholeRowDiscount) / 100)).toFixed(2));
            }
        });

        saveVariant(variant);
    }

    function setWholeRowDiscountPercent(lineItemArticle, variant) {
        var avgPrice = parseFloat(vm.getProductGrossPrice(lineItemArticle).toFixed(2));
        if (!variant.wholeRowPrice) { variant.wholeRowPrice = avgPrice; }
        if (!variant.wholeRowDiscount) { variant.wholeRowDiscount = 0; }
        variant.wholeRowFinalPrice = parseFloat((variant.wholeRowPrice * (1 - variant.wholeRowDiscountPercent)).toFixed(2));

        _.forEach(variant.lineItems, function(li) {
            if (!li.amount || li.amount === 0) {
                li.amount = variant.wholeRowPrice;
                li.finalAmount = parseFloat((parseFloat(variant.wholeRowPrice) * (1 - variant.wholeRowDiscountPercent)).toFixed(2));
            }
            li.discountPercent = variant.wholeRowDiscountPercent;
        });

        saveVariant(variant);
    }

    function getProductGrossPrice(article) {
        var sumPrice = 0, sumTotalQuantity = 0;
        _.forEach(article.lineItemsGroupedOnVariant1, function(liGrp) {
            sumPrice += _.sumBy(liGrp.lineItems, function(li) {
                sumTotalQuantity += li.quantity;
                return li.amount * li.quantity;
            });
        });
        return sumPrice / (sumTotalQuantity === 0 ? 1 : sumTotalQuantity);
    }

    function getVariantQuantitySum(variant) {
        var sumQty = 0;
        sumQty += _.sumBy(variant.lineItems, function(li) {
            return li.quantity;
        });
        return sumQty;
    }

    function getProductQuantitySum(article) {
        var sumQty = 0;
        _.forEach(article.lineItemsGroupedOnVariant1, function(liGrp) {
            sumQty += _.sumBy(liGrp.lineItems, function(li) {
                return li.quantity;
            });
        });
        return sumQty;
    }

    function getTotalQuantitySum() {
        var sumQty = 0;
        _.forEach(vm.lineItemsGroupedByArticle, function(o) {
            sumQty += getProductQuantitySum(o);
        });
        return sumQty;
    }

    function removeArticleFromOrder(article) {
        if (!article || !article.lineItemsGroupedOnVariant1) { return false; }

        confirmationDialogService.showDialog($translate.instant('resellerorder.confirmRemoveArticle'), $translate.instant('common.warning')).then(function (result) {
            if (result === true) {
                _.forEach(article.lineItemsGroupedOnVariant1, function(variant1) {
                    _.forEach(variant1.lineItems, function(li) {
                        if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                            li.quantity = 0;
                            vm.onLineItemChanged({ lineItem: li });
                        }
                    });
                });
                vm.resellerOrder.lineItems = _.filter(vm.resellerOrder.lineItems, function(o) {
                    return o.articleId !== parseInt(article.article.id);
                });
            }
        });
    }
    function canDeleteArticleFromOrder(lineItemsGroupedOnVariant1) {
        if (!lineItemsGroupedOnVariant1) { return false; }

        var canDelete = true;
        _.forEach(lineItemsGroupedOnVariant1, function(variant1) {
            _.forEach(variant1.lineItems, function(li) {
                if (_.find(li.links, function(l) { return l.rel === 'delete'; }) === undefined) {
                    canDelete = false;
                }
            });
        });
        return canDelete;
    }

    function canClearRow() {
        var canUpdateWholeRow = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;
        return canUpdateWholeRow;

        //TODO look on each lineitem if able to upsert
    }

    function confirmClearRow(lineItemsGroupedOnVariant1) {
        confirmationDialogService.showDialog($translate.instant('resellerorder.confirmClearRow'), $translate.instant('common.warning')).then(function (result) {
            if (result === true) {
                _.forEach(lineItemsGroupedOnVariant1.lineItems, function(li) {
                    if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                        li.quantity = 0;
                        vm.onLineItemChanged({ lineItem: li });
                    }
                });
                lineItemsGroupedOnVariant1.wholeRowQuantity = '';
            }
        });
    }

    function canUpdateWholeRow() {
        var canUpdateWholeRow = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;
        return canUpdateWholeRow;

        //TODO look on each lineitem if able to upsert
    }

    function updateWholeRow(variant1, wholeRowQuantity) {
        if (!variant1) { return; }
        if (!variant1.lineItems) { return; }
        if (!wholeRowQuantity || wholeRowQuantity === '') { return; }

        var lineItem = _.find(variant1.lineItems, function(o) { return o.quantity > 0; });
        if (lineItem !== undefined) {
            confirmationDialogService.showDialog($translate.instant('resellerorder.confirmUpdateWholeRow'), $translate.instant('common.warning')).then(function (result) {
                if (result === true) {
                    _.forEach(variant1.lineItems, function(li) {
                        if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                            li.quantity = wholeRowQuantity;
                            vm.onLineItemChanged({ lineItem: li });
                        }
                    });
                }
                variant1.wholeRowQuantity = '';
            });
        } else {
            _.forEach(variant1.lineItems, function(li) {
                if (_.find(li.links, function(l) { return l.rel === 'modify'; }) !== undefined) {
                    li.quantity = wholeRowQuantity;
                    vm.onLineItemChanged({ lineItem: li });
                }
            });
            variant1.wholeRowQuantity = '';
        }
    }

    function toggleExpandAll() {
        var allAreExpanded = true;
        _.forEach(vm.lineItemsGroupedByArticle, function (o) {
            if (!o.article.showRows || o.article.showRows === false) {
                allAreExpanded = false;
            }
        });

        _.forEach(vm.lineItemsGroupedByArticle, function(art) {
            if (!allAreExpanded) {
                art.article.showRows = true;
            } else {
                art.article.showRows = false;
            }
        });
    }

    function getVariant1s(lineItems) {
        var variants = _.chain(lineItems)
            .groupBy('variantDetail1Name')
            .map((value, key) => ({ variantDetail1Name: key, lineItems: value }))
            .value();

        return variants;
    }
    function getVariant2s(lineItems) {
        var variants = _.map(lineItems, 'variantDetail2Name');

        return variants;
    }

    function canModifyLineItem() {
        var canModifyLineItems = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'upsertLineItems'; }) !== undefined;
        return canModifyLineItems;

        //TODO look on each lineitem if able to upsert
    }

    function regroupLineItemsOnArticle() {
        vm.resellerOrder.lineItems = _.sortBy(vm.resellerOrder.lineItems, ['variantDetail1Name', 'variantDetail2SortOrder']);
        vm.lineItemsGroupedByArticle = _.chain(vm.resellerOrder.lineItems)
            // Group the elements of Array based on `color` property
            .groupBy('articleId')
            // `key` is group's name (color), `value` is the array of objects
            .map((value, key) => ({
                article: {
                    displayArticleNumber: value.length > 0 ? value[0].displayArticleNumber : '',
                    articleName: value.length > 0 ? value[0].articleName : '',
                    id: key,
                    showRows: false,
                    plannedDeliveryDate: (_.find(value, function(v) { return v.quantity > 0; }) || value[0]).plannedDeliveryDateUtc
                },
                lineItemsGroupedOnVariant1: regroupLineItemsOnVariant1(value)
            }))
            .value();
        _.forEach(vm.lineItemsGroupedByArticle, function(lineItemArticle) {
            var avgPrice = vm.getProductGrossPrice(lineItemArticle);
            _.forEach(lineItemArticle.lineItemsGroupedOnVariant1, function(variant) {
                variant.initialProductGrossPrice = avgPrice;
                _.forEach(variant.lineItems, function(lineItem) {
                    lineItem.discountDisplayPercent = lineItem.discountPercent * 100 + '%';
                    lineItem.plannedDeliveryDateUtc = !lineItem.plannedDeliveryDateUtc ? lineItemArticle.article.plannedDeliveryDate : lineItem.plannedDeliveryDateUtc;
                });
            });
        });
    }
    function regroupLineItemsOnVariant1(lineItems) {
        var lineItemsGroupedByVariant1 = _.chain(lineItems)
            .groupBy('variantDetail1Name')
            .map((value, key) => ({
                variantDetail1Name: key,
                lineItems: value
            }))
            .value();
        return lineItemsGroupedByVariant1;
    }

    function groupBy(array, field) {
        return _.groupBy(array, field);
    }

    function saveVariant(variant) {
        var v = variant;
        _.forEach(v.lineItems, function(l) { 
            var d = new Date(l.plannedDeliveryDateUtc);
            l.plannedDeliveryDateUtc = dateToUtc(d);
        });
        vm.onVariantChanged({ variant: variant });
    }

    function saveLineItem(lineItem) {
        vm.onLineItemChanged({ lineItem: lineItem });
    }

    function viewOrderArticle(article) {
        vm.onArticleSelected({ article: article });
    }

    function absolute(number) {
        if (_.isNumber(number)) {
            return Math.abs(number);
        }
        return 0;
    }

    function canModifyLineItemDeliveryDate(lineItemArticle) {
        // Planned delivery date can change at any moment (?)
        return true;
    }

    function dateToUtc(date) {
        var milliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
        var d = new Date(milliseconds);
        return d;
    }

    function deliveryDateChanged(lineItemArticle) {
        var newDate = new Date(
            lineItemArticle.article.plannedDeliveryDate.getFullYear(),
            lineItemArticle.article.plannedDeliveryDate.getMonth(),
            lineItemArticle.article.plannedDeliveryDate.getDate(),
            0, 0, 0, 0);

        _.forEach(lineItemArticle.lineItemsGroupedOnVariant1, function(group) {
            _.forEach(group.lineItems, function(lineItem) {
                lineItem.plannedDeliveryDateUtc = newDate;
            });
            saveVariant(group);
        });
    }
}
